var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-badge',{attrs:{"status":"warning","text":""}}),_vm._v(" "),_c('span',{class:['trawl-status-warning']},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }